/* eslint-disable no-param-reassign */
/*
  https://johnresig.com/blog/nodename-case-sensitivity/
  this is the reason we can return the nodeName without worrying about case.
  authored by the creator of jQuery
*/
const CHECKBOX = 'checkbox';
const INPUT = 'INPUT';
const SELECT = 'SELECT';
const UNSUPPORTED = 'UNSUPPORTED';

const inputType = (input) => {
  var { nodeName, type } = input;
  if (nodeName === INPUT && type === CHECKBOX) {
    return CHECKBOX;
  }

  if (nodeName === INPUT || nodeName === SELECT) {
    return nodeName;
  }

  return UNSUPPORTED;
};

const fillCheckbox = (input, val) => {
  input.checked = val;
  return input;
};

const selectOptionOfSelect = (input, val) => {
  var { options } = input;
  Array.prototype.map.call(options, (option, index) => {
    if (option.value === val) {
      input.selectedIndex = index;
    }
  });

  return input;
};

const fillInput = (input, val) => {
  input.value = val;
  return input;
};

const prefillElement = function (input, val) {
  var type = inputType(input);
  switch (type) {
    case INPUT:
      fillInput(input, val);
      break;
    case CHECKBOX:
      fillCheckbox(input, val);
      break;
    case SELECT:
      selectOptionOfSelect(input, val);
      break;
    default:
      fillInput(input, val);
  }
};

const findInputFinder = name => document.querySelector(`input[name="${name}"]`);

const prefillForm = ({
  allowedFields = [],
  data = {},
  findInput = findInputFinder,
}) => {
  var fillFields = (formData) => {
    var updateInput = function (entry) {
      var [name, val] = entry;
      var input = findInput(name);

      if (!input) {
        return;
      }

      prefillElement(input, val);
      input.classList.add('filled');
    };

    Object.entries(formData)
      .filter(entry => allowedFields.indexOf(entry[0]) > -1)
      .map(updateInput);
  };

  fillFields(data);
};

export default prefillForm;
